const EMAIL_FIELD = 'Email';
const HEADER_INDEX = 0;
const LAST_NAME_FIELD = 'Surname';
const NAME_FIELD = 'Name';
const SIS_ID_FIELD = 'SIS ID';

export { EMAIL_FIELD, HEADER_INDEX, LAST_NAME_FIELD, NAME_FIELD, SIS_ID_FIELD };
